<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="row bg-white mb-4">
        <div
          class="col-xl-1 col-lg-2 col-md-3 col-sm-4 col-12 d-flex align-items-center justify-content-center"
        >
          <v-btn class="btn-return" @click="handleBack"
            ><i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar</v-btn
          >
        </div>

        <div class="col-xl-10 col-lg-8 col-md-6 col-sm-4 col-12">
          <div>
            <h6 class="upper-text mb-0">FORMULÁRIO: {{ form.name }}</h6>

            <h6 class="upper-text worksansr text-fourteen m-0">
              DESCRIÇÃO: {{ form.description }}
            </h6>

            <h6 class="upper-text worksansr text-fourteen m-0">
              STATUS: {{ form.status }}
            </h6>

            <h6 class="worksansr">
              Respondido por
              {{
                professionalClassCouncilValue({
                  id: form.user_professional_class_council_id,
                  name: form.user_name,
                  profile: form.user_profile_name,
                  cpf: form.user_cpf,
                  office: form.user_office,
                  value: form.user_professional_class_council_value,
                })
              }}
              - Aberto no dia
              {{ formatDate(form.created_at)
              }}<span v-if="form.updated_at"
                >, finalizado no dia {{ formatDate(form.updated_at) }}.
              </span>
            </h6>
          </div>
        </div>

        <div
          class="col-xl-1 col-lg-2 col-md-3 col-sm-4 col-12 d-flex align-items-center justify-content-center"
        >
          <v-btn class="btn-return" @click="handleToPrint"
            ><i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR</v-btn
          >
        </div>

        <div class="col-md-12 pt-0">
          <div class="v-warning p-2">
            Só pode realizar alterações até 14 horas depois da data que foi
            aberto o formulário!
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mb-3">
        <confirmation-dialog
          certificate
          validate
          v-if="
            form.technical_responsible == 0 &&
            userIsTechnicalResponsible &&
            form.rt_validate == 1
          "
          header-class=""
          message-title="VALIDAR FORMULÁRIO"
          message-body="Deseja realmente Validar essa evolução?"
          open-class="btn-modern btn-modern-save"
          open-left-icon="fas fa-check"
          open-text="VALIDAR FORMULÁRIO"
          @yes="validateSemiology(form.semiology_form_question_answer_id)"
        />

        <ButtonGenerateCertificate
          v-if="form.data_base64"
          :id="form.semiology_form_question_answer_id"
          :data_base64="form.data_base64"
        />
      </div>

      <div v-if="form.can_copy == 1" class="text-right mb-3">
        <confirmation-dialog
          v-if="
            semiology_form_question_answer.answered_copy == 0 &&
            semiology_form_question_answer.form_id != 0 &&
            semiology_form_question_answer.form_id != null &&
            semiology_form_question_answer.status == 'PENDENTE'
          "
          header-class=""
          message-title="RESPONDER COM O ÚLTIMO FORMULÁRIO"
          message-body="Deseja realmente responder esse formulário?"
          open-class="btn-modern btn-modern-info"
          open-left-icon="fas fa-clipboard-check"
          open-text="COPIAR AS RESPOSTA DO ÚLTIMO FORMULÁRIO"
          @yes="
            copyAnswerLastForm(
              semiology_form_question_answer.id,
              semiology_form_question_answer.form_id
            )
          "
        />
      </div>

      <Attachments
        :semiology_form_question_answer_id="
          form.semiology_form_question_answer_id
        "
      />

      <v-expansion-panels accordion mandatory v-model="current_panel">
        <v-expansion-panel v-for="category in categories" :key="category.id">
          <v-expansion-panel-header class="back-ground-grey2">
            <h6 class="mb-0 upper-text">
              <span class="worksansr">CATEGORIA:</span> {{ category.name }}

              <br />

              <div v-if="!category.linked_profile_id_can_answer">
                <span class="mandatory-data worksansr">
                  <i class="fas fa-exclamation-circle"></i>

                  Seu perfil não tem permissão para responder essa categoria
                </span>
              </div>

              <br />

              <div v-if="category.linked_profile_name">
                <span class="worksansr">Perfis vinculados:</span>
                <div
                  v-for="profile_name in category.linked_profile_name"
                  :key="profile_name"
                >
                  <small>{{ profile_name }}</small>
                </div>
              </div>

              <span class="worksansr text-thirteen"
                >({{ category.questions.length }}
                {{
                  category.questions.length > 1 ? "perguntas" : "pergunta"
                }})</span
              >
            </h6>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <div
              class="row"
              v-for="(question, question_index) in category.questions"
              :key="question.id"
            >
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h6>
                  {{ question_index + 1 }}. {{ question.statement }}
                  <span class="mandatory-data worksansr">
                    {{ question.mandatory == 1 ? "(Obrigatório)" : "" }}</span
                  >
                </h6>

                <Open
                  v-if="question.semiology_form_question_type_value == 'OPEN'"
                  :form="form"
                  :question="question"
                  :category_id="category.id"
                  :linked_profile_id_can_answer="
                    category.linked_profile_id_can_answer
                  "
                  v-on:answer="handleChangeAnswerQuestions"
                />

                <Rating
                  v-if="question.semiology_form_question_type_value == 'RATING'"
                  :form="form"
                  :category_id="category.id"
                  :question="question"
                  :linked_profile_id_can_answer="
                    category.linked_profile_id_can_answer
                  "
                  v-on:answer="handleChangeAnswerQuestions"
                />

                <SingleChoice
                  v-if="
                    question.semiology_form_question_type_value ==
                    'SINGLE_CHOICE'
                  "
                  :form="form"
                  :category_id="category.id"
                  :question="question"
                  :linked_profile_id_can_answer="
                    category.linked_profile_id_can_answer
                  "
                  v-on:answer="handleChangeAnswerQuestions"
                />

                <MultipleChoice
                  v-if="
                    question.semiology_form_question_type_value ==
                    'MULTIPLE_CHOICE'
                  "
                  :form="form"
                  :category_id="category.id"
                  :question="question"
                  :linked_profile_id_can_answer="
                    category.linked_profile_id_can_answer
                  "
                  v-on:answer="handleChangeAnswerQuestions"
                />

                <Dichotomous
                  v-if="
                    question.semiology_form_question_type_value == 'DICHOTOMOUS'
                  "
                  :form="form"
                  :category_id="category.id"
                  :question="question"
                  :linked_profile_id_can_answer="
                    category.linked_profile_id_can_answer
                  "
                  v-on:answer="handleChangeAnswerQuestions"
                />
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <ErrorsMessages :errors="errors" />
      </div>

      <div class="text-right">
        <v-btn
          v-if="form.status == 'PENDENTE'"
          @click="answerQuestions"
          :disabled="loading"
          class="btn-save"
        >
          <i class="fas fa-save mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}</v-btn
        >

        <hr />

        <p class="worksansr m-0">
          Para finalizar o formulário, responda as questões, clique em SALVAR
          para depois finalizar.
        </p>

        <confirmation-dialog
          class="ml-2"
          v-if="semiology_form_question_answer.status == 'PENDENTE'"
          message-title="CONFIRMAÇÃO"
          message-body="TEM CERTEZA QUE DESEJA EXCLUIR O FORMULÁRIO?"
          open-class="btn-delete"
          open-text="EXCLUIR FORMULÁRIO"
          openLeftIcon="fa-times"
          @yes="deleteSemiologyAnswer"
        />

        <confirmation-dialog
          certificate
          class="ml-2"
          v-if="semiology_form_question_answer.status == 'PENDENTE'"
          message-title="CONFIRMAÇÃO"
          message-body="TEM CERTEZA QUE DESEJA FINALIZAR O FORMULÁRIO?"
          open-class="btn-save"
          open-text="FINALIZAR FORMULÁRIO"
          openLeftIcon="fa-check"
          @yes="finish"
        />

        <confirmation-dialog
          certificate
          class="ml-2"
          v-if="
            permission('read', 'master_finish_semiology') &&
            form.user_id != user_id &&
            semiology_form_question_answer.status == 'PENDENTE'
          "
          message-title="CONFIRMAÇÃO"
          message-body="TEM CERTEZA QUE DESEJA FINALIZAR O FORMULÁRIO?"
          open-class="btn-save"
          open-text="FINALIZAR FORMULÁRIO COMO MASTER"
          openLeftIcon="fa-check"
          @yes="finishByMaster"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import ConfirmationDialog from "../../Components/ConfirmationDialog";

import ButtonGenerateCertificate from "../../Components/ButtonGenerateCertificate";

import toast from "../../../lib/ToastNotification";

import Open from "./Answered/Open";

import Rating from "./Answered/Rating";

import SingleChoice from "./Answered/SingleChoice";

import MultipleChoice from "./Answered/MultipleChoice";

import Dichotomous from "./Answered/Dichotomous";

import Attachments from "./Answered/Attachments";

import { professionalClassCouncilValue, formatDate } from "../../../lib/format";

import api from "../../../services/api";

import permission from "../../../lib/permission";

import { userData } from "../../../lib/functions";

import BRyHUB from "../../../lib/BRy/hub";

export default {
  name: "AnsweredForm",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    ButtonGenerateCertificate,
    Open,
    Rating,
    SingleChoice,
    MultipleChoice,
    Dichotomous,
    Attachments,
  },

  props: {
    resident_id: [String, Number],
    form: Object,
  },

  data() {
    return {
      userIsTechnicalResponsible: false,

      user_id: null,

      user_profile_id: null,

      current_panel: 0,

      categories: [],

      MULTIPLE_CHOICE: "MULTIPLE_CHOICE",

      DICHOTOMOUS: "DICHOTOMOUS",

      SINGLE_CHOICE: "SINGLE_CHOICE",

      RATING: "RATING",

      OPEN: "OPEN",

      answer: [],

      semiology_form_question_answer: {},

      allAnswered: true,

      loading: false,

      errors: [],
    };
  },

  async created() {
    let { user } = userData();

    this.user_id = user.id;

    this.user_profile_id = user.user_profile_id;

    await this.get();

    if (user.technical_responsible == 1) {
      this.getUserIsTechnicalResponsible();
    }
  },

  methods: {
    formatDate,
    professionalClassCouncilValue,
    permission,

    async get() {
      try {
        this.loading = true;

        let {
          form: { semiology_form_id, semiology_form_question_answer_id },
        } = this;

        let params = { semiology_form_id, semiology_form_question_answer_id };

        let response = await api.get(
          "/rest-home/answer-semiology/answered-form",
          {
            params,
          }
        );

        let {
          error,
          errors,
          categories,
          allAnswered,
          semiology_form_question_answer,
        } = response.data;

        if (!error) {
          this.categories = categories;
          this.allAnswered = allAnswered;
          this.semiology_form_question_answer = semiology_form_question_answer;
          this.form.updated_at = semiology_form_question_answer.updated_at;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async answerQuestions() {
      try {
        this.loading = true;

        const { resident_id, form, answer } = this;

        let answerFormated = [];

        for (let category of answer) {
          let questions = [];

          for (let question of category.questions) {
            if (
              question.semiology_form_question_type_value == "MULTIPLE_CHOICE"
            ) {
              if (
                question.answer &&
                question.answer != undefined &&
                typeof question.answer == "object" &&
                question.answer.length > 0
              ) {
                let is = [];
                for (let i of question.answer) {
                  is.push({ id: i.id, checked: i.checked });
                }
                question.answer = is;
              }
            }

            questions.push({
              semiology_form_question_type_value:
                question.semiology_form_question_type_value,
              answer: question.answer,
              text: question.text,
              id: question.id,
              answered: question.answered,
              mandatory: question.mandatory,
            });
          }
          answerFormated.push({
            questions,
          });
        }

        let params = {
          resident_id,
          form: {
            semiology_form_question_answer_id:
              form.semiology_form_question_answer_id,
            user_id: form.user_id,
          },
          answer: answerFormated,
        };
        const response = await api.put(
          "/rest-home/answer-semiology/form",
          params
        );
        const { error, errors, message } = response.data;
        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.get();
          this.answer = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async finishByMaster() {
      try {
        this.loading = true;

        const { resident_id, form, answer } = this;

        let {
          form: { semiology_form_id, semiology_form_question_answer_id },
        } = this;

        let params = {
          resident_id,
          form,
          answer,
        };
        const response = await api.post(
          "/rest-home/answer-semiology/form-finish-master",
          params
        );
        const { error, errors, message } = response.data;
        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.get();
          this.$emit("update");

          await BRyHUB.authorize({
            id: `${resident_id},${semiology_form_id},${semiology_form_question_answer_id}`,
            table: "semiology_form_question_answer",
          });
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async finish() {
      try {
        this.loading = true;

        const { resident_id, form, answer } = this;

        let {
          form: { semiology_form_id, semiology_form_question_answer_id },
        } = this;

        let params = {
          resident_id,
          form,
          answer,
        };
        const response = await api.post(
          "/rest-home/answer-semiology/form-finish",
          params
        );
        const { error, errors, message } = response.data;
        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.get();
          this.$emit("update");

          await BRyHUB.authorize({
            id: `${resident_id},${semiology_form_id},${semiology_form_question_answer_id}`,
            table: "semiology_form_question_answer",
          });
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteSemiologyAnswer() {
      try {
        this.loading = true;

        const { resident_id, form } = this;

        let data = { resident_id, form };

        const response = await api.delete(
          "/rest-home/answer-semiology/form-delete",
          { data }
        );

        const { error, errors, message } = response.data;
        if (!error) {
          toast(message, "success");
          this.errors = [];
          this.$emit("delete");
          this.handleBack();
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getUserIsTechnicalResponsible() {
      try {
        this.loading = true;

        const type = "SEMIOLOGIA";

        let params = { type };

        let response = await api.get("/technical-responsible/user", { params });

        let { userIsTechnicalResponsible } = response.data;

        this.userIsTechnicalResponsible = userIsTechnicalResponsible;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async validateSemiology(id) {
      try {
        this.loading = true;

        let {
          resident_id,
          form: { semiology_form_id },
        } = this;

        let params = { id, table_name: "semiology_form_question_answer" };

        let response = await api.put("/technical-responsible", params);

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.userIsTechnicalResponsible = false;

          await BRyHUB.authorize({
            id: `${resident_id},${semiology_form_id},${id}`,
            table: "semiology_form_question_answer",
          });
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async copyAnswerLastForm(question_answer_id, form_id) {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = { question_answer_id, form_id, resident_id };

        let response = await api.put(
          "/rest-home/answer-semiology/form-copy",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];

          toast(message, "success");

          this.get();
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleChangeAnswerQuestions(e) {
      let { categories } = this;

      for (let category of categories) {
        if (category.id == e.category_id) {
          for (let question of category.questions) {
            if (question.id == e.id) {
              question.answer = e.answer;
              question.text = e.text;
            }
          }
        }
      }

      this.answer = categories;
    },

    handleToPrint() {
      let {
        resident_id,
        form: { semiology_form_id, semiology_form_question_answer_id },
      } = this;

      let route = this.$router.resolve({
        name: "print-semiology",
        params: {
          resident_id,
          semiology_form_id,
          semiology_form_question_answer_id,
        },
      });

      window.open(route.href, "_blank");
    },

    handleBack() {
      this.$emit("clickRowTable");
    },
  },
};
</script>